import { FormattedMessage } from 'react-intl';

import { FormField } from '../../../../forms/formField/index';
import { numbersOnly } from '../../../../forms/helpers/normalisers';
import messages from '../CompanyDetails.messages';

export const AnnualProfitQuestion = (props) => {
    const { onChange } = props;

    return (
        <FormField
            className="fs-exclude"
            label={<FormattedMessage {...messages.annualProfit} />}
            name="annualProfit"
            id="annualProfit"
            onChangeHandler={onChange}
            normalize={numbersOnly}
        />
    );
};
